<template>
  <div class="page-container">
    <div class="header-container ">
      <header-bar></header-bar>
    </div>
    <div class="home-container">
      <transition :name="transitionName">
        <router-view></router-view>
      </transition>
    </div>
    <div class="footer-container">
      <footer-bar></footer-bar>
    </div>

    <div class="modal-bg" v-show="showModalBg"></div>
  </div>
</template>
<script>
import footerBar from '@/components/footer'
import headerBar from '@/components/header'
export default {
  name: 'home',
  components: {
    footerBar,
    headerBar
  },
  data() {
    return {
      transitionName: '',
      menuIndex: -1,
    }
  },
  watch: {
    $route(to, from) {
      let name = to.name
      if (name != 'trade') {
        this.menuIndex = -1
      } else {
        let type = this.$route.query.type
        this.menuIndex = type == 2 ? 0 : (type == 3 ? 1 : (type == 1 ? 2 : 0))
      }
    },
  },
  computed: {
    showModalBg() {
      return this.$store.state.showModalBg
    },
  },
  mounted() {
    let routeName = this.$route.name
    if (routeName == 'trade') {
      let type = this.$route.query.type
      this.menuIndex = type == 2 ? 0 : (type == 3 ? 1 : (type == 1 ? 2 : 0))
    }
  },
  methods: {
  
    chooseMenu(i, data) {
      this.menuIndex = i
      if (i == 3) {
        sessionStorage.setItem('routeBak', this.$route.name)
        sessionStorage.setItem('routeQuery', JSON.stringify(this.$route.query))
        this.$router.replace({
          name: 'imitate',
        })
      } else {
        this.$router.replace({
          name: 'trade',
          query: {
            type: data.type
          }
        })
      }
      this.$store.state.showMenuModal = false
    }
  }
}
</script>